/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import "./src/styles/global.scss"
import "./src/styles/screen.scss"
import "./src/styles/typography.scss"

import Axios from "axios"

export const onClientEntry = () => {
  const isBrowser = () => typeof window !== "undefined"

  if (isBrowser()) {
    Axios.get(
      "https://api.ipstack.com/check?access_key=1a72a96a01795e2221c2806d2df1d014"
    )
      .then(response => {
        const countryCode = response.data.country_code

        if (countryCode) {
          localStorage.setItem("country", countryCode)
        }
      })
      .catch(err => {
        localStorage.setItem("country", "INT")
      })
  }
}
